import Image from 'next/image';
import React, { Component } from 'react';

import AAAModal from '../modals/AAAModal';
import FeedbackModal from '../modals/FeedbackModal';

class CampaignBanner extends Component {
	constructor(props) {
		super(props);

		this.state = {
			modalTermsOfServiceOpen: false,
			termsOfServiceContent: '',
			aaaMemberShipPrompt: false,
			test: 0,
		};
	}

	onOpenModal = () => {
		this.setState({ modalTermsOfServiceOpen: true });
	};

	onCloseAAAModal = () => {
		setTimeout(() => {
			this.setState({ aaaMemberShipPrompt: false }, function () {
				console.log(this.state.aaaMemberShipPrompt, 'aaaMemberShipPrompt');
			});
		}, 1);
	};

	onCloseModal = () => {
		setTimeout(() => {
			this.setState({ modalTermsOfServiceOpen: false }, function () {
				console.log(this.state.modalTermsOfServiceOpen, 'modalTermsOfServiceOpen');
			});
		}, 1);
	};

	onOpenAAAModal = () => {
		this.setState({ aaaMemberShipPrompt: true });
	};

	render() {
		const { campaigns } = this.props;
		return (
			<div className="discounts">
				<FeedbackModal
					open={this.state.modalTermsOfServiceOpen}
					type="info"
					title="Terms of Service"
					content={this.state.termsOfServiceContent}
					onCloseModal={this.onCloseModal}
					confirmAction={this.onCloseModal}
					buttonConfirm={'OK'}
				/>

				{campaigns &&
					campaigns.map((item, index) => {
						if (item.campaignType === 1) {
							if (!item.redirectURL) {
								return (
									<div
										className="discount-item"
										onClick={() =>
											this.setState({
												modalTermsOfServiceOpen: true,
												termsOfServiceContent: item.terms,
											})
										}
										key={index}>
										<span className="content">
											<span className="amount">
												{item.discountAmount > 0 && (
													<span className="amount">${item.discountAmount} OFF - </span>
												)}
											</span>
											<span className="details">
												<span className="mr-1">{item.campaignText}</span>
												<Image
													width="100px"
													height="100px"
													objectFit="contain"
													src={item.campaignImageUrl}
													alt=""
												/>
											</span>
										</span>
									</div>
								);
							} else {
								return (
									<div className="discount-item" key={index}>
										<a href={item.redirectURL}>
											<span className="content">
												{item.discountAmount > 0 && (
													<span className="amount">${item.discountAmount} OFF - </span>
												)}
												<span className="details">
													<span className="mr-1">{item.campaignText}</span>
													<Image
														width="100px"
														height="100px"
														objectFit="contain"
														src={item.campaignImageUrl}
														alt=""
													/>
												</span>
											</span>
										</a>
									</div>
								);
							}
						}
						if (item.campaignType === 5) {
							// AAA Membershipship Prompt

							return (
								<div
									className="discount-item"
									onClick={() =>
										this.setState({
											aaaMemberShipPrompt: true,
											termsOfServiceContent: item.terms,
										})
									}
									key={index}>
									<AAAModal
										open={this.state.aaaMemberShipPrompt}
										type="info"
										title="Verify AAA Membership"
										content={item.terms}
										onCloseModal={this.onCloseAAAModal}
										confirmAction={this.onCloseAAAModal}
										declineAction={this.onCloseAAAModal}
										buttonConfirm={'OK'}
										buttonDecline={'Cancel'}
										priceLevel={item.priceLevel}
									/>

									<span className="content">
										<span className="amount">
											{item.discountAmount > 0 && (
												<span className="amount">${item.discountAmount} OFF - </span>
											)}
										</span>
										<span className="details">
											<span className="mr-1">{item.campaignText}</span>
											<Image
												width="100px"
												height="100px"
												objectFit="contain"
												src={item.campaignImageUrl}
												alt=""
											/>
										</span>
									</span>
								</div>
							);
						} else return '';
					})}
			</div>
		);
	}
}

export default CampaignBanner;
